import {Pipe, PipeTransform} from "@angular/core";
import {DatePipe} from "@angular/common";

@Pipe({name: "woaTime"})
export class WOATimePipe implements PipeTransform {
    transform(value: any, args?: string): any {
        // We need to use en-GB for 24-hour times, and en-US for 12 hour times due to chrome's time formatting quirks.
        const locale: string = args && args.indexOf("hh") >= 0 ? "en-US" : "en-GB";
        return new DatePipe(locale).transform(value, args || "HH:mm");
    }
}



// WEBPACK FOOTER //
// ./src/app/string-utils/time.pipe.ts